export const BASE_URL = "https://v0-9gxg.onrender.com";
export const AUTH_VERIFICATION_BASE_URL = "http://localhost:3019";
//REACT_APP_CLERK_PUBLISHABLE_KEY=pk_test_c3RpbGwtcm91Z2h5LTUuY2xlcmsuYWNjb3VudHMuZGV2JA
